export const FLOW_BOT_VARIABLES = [
    { name: 'Nome do Contato', value: '{{nome_contato}}' },
    { name: 'Telefone', value: '{{phoneNumber}}' },
    { name: 'Saudação', value: '{{ms}}' },
    { name: 'Data', value: '{{date}}' },
    { name: 'Hora', value: '{{hour}}' },
    { name: 'Data e Hora', value: '{{date_hour}}' },
    { name: 'Protocolo', value: '{{protocol}}' },
    { name: 'Ticket ID', value: '{{ticket_id}}' },
];

export const FLOW_BOT_SINGLE_BLOCK_EXTRA_VARIABLES = [
    { name: 'Nome Empresa', value: '{{companyName}}' },
    { name: 'Email Empresa', value: '{{companyEmail}}' },
];
